import { bookingSource } from "config/envConfig";
import apiList from "services/apiList";
import { callApi } from "services/callApi";
import {
  ALLOW_ALL_STORES_KEY,
  BOOKING_SOURCE,
  DATA_REFERENCE,
  STORE_LIST_KEY,
} from "./Constants";

function getShopId() {
  try {
    const data = JSON.parse(localStorage.getItem(DATA_REFERENCE)) || {};
    const allowAll =
      data[ALLOW_ALL_STORES_KEY] !== undefined
        ? data[ALLOW_ALL_STORES_KEY]
        : true;
    const storeList = Array.isArray(data[STORE_LIST_KEY])
      ? data[STORE_LIST_KEY]
      : [];

    if (!allowAll && storeList.length === 1) {
      return storeList[0];
    }
  } catch {}
  return "";
}

export async function getProductDetails(productId) {
  let apiURL = apiList.products.productDetail;
  const data = JSON.parse(localStorage.getItem(DATA_REFERENCE));
  const rnBookingSource =
    data && data[BOOKING_SOURCE] ? data[BOOKING_SOURCE] : bookingSource || "";

  const response = await callApi.post(apiURL, {
    itemId: "",
    barCode: productId,
    rule_id: [],
    shopId: getShopId(),
    bookingSource: rnBookingSource,
  });

  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}
